import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-purchase-orders',
  templateUrl: './purchase-orders.component.html',
  styleUrls: ['./purchase-orders.component.css']
})
export class PurchaseOrdersComponent implements OnInit {


  selectedTab = 'wip_orders';
  activeTab = "wip_orders";
  tab_search: any;
   data:any;
  constructor(private route:ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      let tab;
          if(params['tab']){
            if(params['tab'] == 'wip_orders'){
              tab = 'wip_orders'
            }else if(params['tab'] == 'released_orders'){
              tab = 'released_orders'
            } else if(params['tab'] == 'inventory'){
              tab= 'inventory'
            }
          }
       tab ? this.activateTab(tab): this.activateTab("wip_orders");
          console.log(params)

    });
 this.data = "";
  }

  //to get active card or tab
  activateTab(tab) {
    this.selectedTab = tab;
    switch (tab) {
      case "wip_orders":
        this.activeTab = "wip_orders";
        break;
      case "released_orders":
        this.activeTab = "released_orders";
        this.tab_search = "released_orders";
        break;
      case "inventory":
        this.activeTab = "inventory";
        this.tab_search = "inventory";
        break;
    }
  

  }
  FiltersObject ={
    Search:'',
    data_type:'',
   
  }
  SetLocalStorate(name,value){
    this.FiltersObject[name] = value
    
    localStorage.setItem('filtersValue',JSON.stringify(this.FiltersObject))
  
  }

}




// WEBPACK FOOTER //
// ./src/app/platform/category/category/purchase-orders/purchase-orders.component.ts